module.exports = __webpack_public_path__ + "img/icon-shop-brand.1d5ed005.svg";